var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BModal',{attrs:{"visible":_vm.value,"hide-footer":"","hide-header":"","size":"lg"},on:{"change":function($event){return _vm.$emit('input', $event)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }